// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Vis adgangskode',
    hide: 'Skjul adgangskode',
    copy: 'Kopiér',
    copied: 'Kopieret',
    once: 'Vises kun nu. Kopiér den, og gem den et sikkert sted.',
  },
  loading: 'Indlæser ændringen…',
  load_failed: 'Jeg kunne ikke indlæse denne ændring.',
  load_retry: 'Prøv igen',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Denne ændring vises her, når Amigo er tilbage. Intet er ændret.',
    assistant: 'Denne ændring vises her, når assistenten er tilbage. Intet er ændret.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Dette blev allerede godkendt, så der var ikke mere at gøre.',
  action_failed: 'Det lykkedes ikke, så intet er ændret. Prøv igen om lidt.',
  removed: 'Fjernet',
  retry: 'Prøv igen',
  retry_one: 'Prøv {{name}} igen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Godkendt.',
    retried: 'Prøvet igen.',
    rejected: 'Afvist.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Sprunget over på kortet.',
  },
  done: {
    summary_one: 'Færdig. {{count}} ændring udført.',
    summary_other: 'Færdig. {{count}} ændringer udført.',
    skipped_one: '{{count}} sprunget over, intet er ændret for den.',
    skipped_other: '{{count}} sprunget over, intet er ændret for dem.',
  },
  partial: {
    summary_one: '{{applied}} af {{approved}} ændringer udført. {{count}} blev ikke udført.',
    summary_other: '{{applied}} af {{approved}} ændringer udført. {{count}} blev ikke udført.',
    detail_one: 'De {{applied}} er gemt. Intet er ændret for de {{count}} nedenfor.',
    detail_other: 'De {{applied}} er gemt. Intet er ændret for de {{count}} nedenfor.',
  },
  stale: {
    summary: '{{applied}} af {{approved}} ændringer udført.',
    detail_one: '{{count}} blev ændret af en anden i mellemtiden.',
    detail_other: '{{count}} blev ændret af en anden i mellemtiden.',
    reason:
      '{{name}} ændrede den til {{value}} kl. {{time}}, før du godkendte, så jeg lod den være. Her er den igen ud fra den nye værdi:',
    decided_done:
      '{{name}} ændrede det til {{value}} kl. {{time}}, før du godkendte, så jeg lod det være. Det nye forslag blev godkendt på sit eget kort.',
    decided_rejected:
      '{{name}} ændrede det til {{value}} kl. {{time}}, før du godkendte, så jeg lod det være. Det nye forslag blev afvist.',
    decided_replaced:
      '{{name}} ændrede det til {{value}} kl. {{time}}, før du godkendte, så jeg lod det være. Det nye forslag blev erstattet af et nyere kort.',
    decided_expired:
      '{{name}} ændrede det til {{value}} kl. {{time}}, før du godkendte, så jeg lod det være. Det nye forslag er udløbet.',
  },
  undo_partly_one: '{{count}} af disse kan ikke fortrydes.',
  undo_partly_other: '{{count}} af disse kan ikke fortrydes.',
  undone: {
    summary_one: 'Fortrudt. Den {{count}} ændring er tilbage som før.',
    summary_other: 'Fortrudt. De {{count}} ændringer er tilbage som før.',
    detail: 'Fortrydelsen er også registreret i Amigo-loggen og under Menu → Redigeringshistorik.',
    partly_summary: 'Delvist fortrudt. {{undone}} af {{count}} ændringer er tilbage som før.',
    partly_changed_one: '{{count}} blev ændret af en anden siden, så den forbliver som den er.',
    partly_changed_other: '{{count}} blev ændret af en anden siden, så de forbliver som de er.',
    partly_kept_one: '{{count}} var allerede tilbage til tidligere tilstand.',
    partly_kept_other: '{{count}} var allerede tilbage til tidligere tilstand.',
    partly_cannot_one: '{{count}} kan ikke fortrydes, f.eks. en sletning, og forbliver som den er.',
    partly_cannot_other: '{{count}} kan ikke fortrydes, f.eks. en sletning, og forbliver som de er.',
    partly_left_one: '{{count}} forbliver som den er.',
    partly_left_other: '{{count}} forbliver som de er.',
  },
  summary: {
    group_one: '{{count}} ret: {{reason}}',
    group_other: '{{count}} retter: {{reason}}',
    group_names_more_one: '{{names}} og {{count}} mere',
    group_names_more_other: '{{names}} og {{count}} mere',
    average: '{{amount}} pr. ret i gennemsnit',
    needs_look: 'Kræver opmærksomhed',
    nothing_else: 'Intet andet ændres',
  },
  labels: {
    waiting: 'Afventer',
    skip: 'Spring over',
    unskip: 'Fortryd overspringning',
    approve_all: 'Godkend alle',
    approve_one: 'Godkend {{count}}',
    approve_other: 'Godkend {{count}}',
    approve_all_count_one: 'Godkend alle {{count}}',
    approve_all_count_other: 'Godkend alle {{count}}',
    approve_row: 'Godkend',
    reject: 'Kassér',
    reject_confirm: 'Afvis',
    back: 'Tilbage',
    why: {
      amigo: 'Hvorfor ikke? (valgfrit, Amigo læser dette)',
      assistant: 'Hvorfor ikke? (valgfrit, assistenten læser dette)',
    },
    hint: 'Eller svar nedenfor for at ændre noget.',
    show_all_one: 'Vis alle {{count}} ændringer',
    show_all_other: 'Vis alle {{count}} ændringer',
    show_less: 'Vis færre',
    applying_one: 'Udfører {{count}} ændring…',
    applying_other: 'Udfører {{count}} ændringer…',
    high_impact: 'Stor effekt',
    done: 'Færdig',
    running: 'Kører',
    show_changes: 'Vis ændringer',
    hide_changes: 'Skjul ændringer',
    rows: {
      skipped: 'Sprunget over',
      applied: 'Udført',
      failed: 'Ikke udført',
      changed: 'Ændret i mellemtiden',
      kept: 'Lad være som den er',
    },
    history: {
      amigo: 'Åbn i Amigo-loggen',
      assistant: 'Åbn i assistentens log',
    },
    undo: 'Fortryd',
    to: 'til',
    from: 'fra',
    rejected: 'Afvist',
    replaced: 'Erstattet',
    expired: 'Udløbet',
  },
};
